import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFadeOut16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFadeOut16"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#FadeOut16)">
                    <path
                        fill="currentColor"
                        d="M7.316 15.106a.6.6 0 0 1-.146-.02A7.13 7.13 0 0 1 .836 8.003l.01-.367A7.13 7.13 0 0 1 7.149.922a.6.6 0 0 1 .167-.027.6.6 0 0 1 .6.6v13.01a.6.6 0 0 1-.6.6m2.42-.35a.6.6 0 0 1-.6-.6V1.846a.6.6 0 0 1 1.199 0v12.31a.6.6 0 0 1-.6.6M6.715 2.208a5.93 5.93 0 0 0-4.68 5.795 5.93 5.93 0 0 0 4.68 5.795zm5.432 11.266a.6.6 0 0 1-.6-.6V3.126a.6.6 0 1 1 1.2 0v9.748a.6.6 0 0 1-.6.6m2.415-2.176a.6.6 0 0 1-.6-.6V5.305a.6.6 0 1 1 1.2 0v5.393a.6.6 0 0 1-.6.6"
                    />
                </g>
                <defs>
                    <clipPath id="FadeOut16">
                        <path fill="#fff" d="M0 16h16V0H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconFadeOut16);
